package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.ActorId
import xim.poc.ActorManager
import xim.poc.ModelLook
import xim.poc.NoOpActorController
import xim.poc.game.*
import xim.poc.game.actor.components.discardNotEquippedItems
import xim.poc.game.actor.components.getInventory
import xim.poc.game.configuration.NoActionBehaviorId
import xim.poc.game.configuration.constants.itemFernStone_9211
import xim.poc.game.configuration.v0.FloorEntity
import xim.poc.game.configuration.v0.GameV0
import xim.poc.game.configuration.v0.interactions.NpcInteraction
import xim.poc.game.event.InitialActorState
import xim.poc.ui.ChatLog
import xim.poc.ui.ChatLogColor
import xim.poc.ui.ShiftJis
import xim.resource.DatId
import xim.resource.InventoryItems

class TacticsInstinctRoller: FloorEntity {

    val promise = spawn()

    override fun update(elapsedFrames: Float) { }

    override fun cleanup() {
        promise.cleanup()
    }

    private fun spawn(): ActorPromise {
        return GameEngine.submitCreateActorState(
            InitialActorState(
                name = "Instinct Roller",
                type = ActorType.StaticNpc,
                position = Vector3f(x=275f,y=8.00f,z=287f),
                modelLook = ModelLook.npc(0x9E2),
                movementController = NoOpActorController(),
                behaviorController = NoActionBehaviorId,
            )
        ).onReady {
            GameV0.interactionManager.registerInteraction(it.id, TacticsInstinctRollerInteraction())
        }
    }

}

private class TacticsInstinctRollerInteraction: NpcInteraction {

    companion object {
        private var describedSelf: StatRank? = null
    }

    override fun onInteraction(npcId: ActorId) {
        describeSelf(npcId)

        ActorManager[npcId]?.playRoutine(DatId("cait"))
        ActorStateManager[npcId]?.faceToward(ActorStateManager.player())

        val itemName = InventoryItems[itemFernStone_9211].name

        UiStateHelper.openQueryMode(
            promptProvider = { "Offer ${ShiftJis.colorItem}1 ${itemName}${ShiftJis.colorClear}? (${getFernStoneCount()} remaining)" },
            optionsProvider = { getOptions() },
            drawFn = { drawUnit(it) }
        ) { handleUnitChoice(it) }
    }

    private fun getFernStoneCount(): Int {
        return ActorStateManager.player().getInventory().getByItemId(itemFernStone_9211).sumOf { it.quantity }
    }

    private fun getOptions(): List<QueryMenuOption> {
        val units = TacticsState.getPlayerUnits()
        return units.map { QueryMenuOption(it.name, it.id) } + QueryMenuOption("Cancel", -1)
    }

    private fun drawUnit(option: QueryMenuOption) {
        val unit = TacticsState.getPlayerUnits().firstOrNull { it.id == option.value } ?: return
        TacticsUnitDescription.drawUnitDescription(unit = unit, type = ActorType.AllyNpc)
    }

    private fun handleUnitChoice(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null || queryMenuOption.value < 0) { return QueryMenuResponse.pop }
        val unit = TacticsState.getPlayerUnits().firstOrNull { it.id == queryMenuOption.value } ?: return QueryMenuResponse.pop

        ActorStateManager.player().discardNotEquippedItems(itemFernStone_9211, quantity = 1)

        val instinctChoices = TacticsInstincts.getRandom(getInstinctRank(), count = 3)

        TacticsInstinctConsumeUi(
            unit = unit,
            instinctOptions = instinctChoices,
            onCompleteCallback = {},
        ).push()

        return QueryMenuResponse.noop
    }

    private fun getInstinctRank(): StatRank {
        return if (TacticsState.hasClearedChallenge(tacticsChallenge_Disjoined)) {
            StatRank.B
        } else if (TacticsState.hasClearedChallenge(tacticsChallenge_Nought)) {
            StatRank.C
        } else {
            StatRank.D
        }
    }

    private fun describeSelf(npcId: ActorId) {
        val currentPower = getInstinctRank()

        if (describedSelf == currentPower) { return }
        describedSelf = currentPower

        val name = ActorStateManager[npcId]?.name ?: ""
        ChatLog("The ${ShiftJis.colorWhite}${name}${ShiftJis.colorClear} is currently ${ShiftJis.colorAug}Rank ${currentPower.name}.${ShiftJis.colorClear} Its instincts will become stronger as more challenges are cleared.", ChatLogColor.Info)
    }

}